import type { RenderSnapshot } from './RendererInterface';
import { divePhase, mouthOpen } from '../game/platforms';
import { snapshotLadyPosition as ladyPosition } from './RendererInterface';
import { background } from './backgrounds';
import { drawCar, drawCroc, drawFly, drawFrog, drawLog, drawSnake, drawTurtles } from './sprites';
import { hud } from './hud';
import { P } from './palette';
import { centered, text, textWidth } from './font';
import { deathAnimation } from './animations';

export class Renderer {
  private ctx:CanvasRenderingContext2D;
  private staticLayer:HTMLCanvasElement;
  constructor(readonly canvas:HTMLCanvasElement){
    canvas.width=224;canvas.height=256;
    const ctx=canvas.getContext('2d',{alpha:false});if(!ctx)throw new Error('Canvas 2D is required');
    this.ctx=ctx;this.ctx.imageSmoothingEnabled=false;
    this.staticLayer=document.createElement('canvas');this.staticLayer.width=224;this.staticLayer.height=256;
    background(this.staticLayer.getContext('2d')!);
  }
  draw(e:RenderSnapshot,title=false,wallTime=0):void {
    const ctx=this.ctx;ctx.imageSmoothingEnabled=false;ctx.drawImage(this.staticLayer,0,0);
    ctx.save();ctx.beginPath();ctx.rect(0,24,224,216);ctx.clip();
    for(const p of e.platforms){
      if(p.kind==='log')drawLog(ctx,p.x,p.y,p.w);
      else if(p.kind==='turtle')drawTurtles(ctx,p.x,p.y,p.w,divePhase(p,e.frame),e.frame);
      else drawCroc(ctx,p.x,p.y,p.w,p.speed>0,mouthOpen(e.frame,p.phaseOffset));
    }
    for(const v of e.vehicles)drawCar(ctx,v);
    for(const h of e.homes){
      if(h.occupied)drawFrog(ctx,h.x,40,'down');
      else if(h.fly)drawFly(ctx,h.x,39,e.frame);
      else if(h.crocodile)drawCroc(ctx,h.x-9,40,18,true,true);
    }
    for(const enemy of e.enemies){
      if(!enemy.active)continue;
      if(enemy.kind==='snake')drawSnake(ctx,enemy.x,enemy.y,enemy.w,e.frame);
      else {ctx.fillStyle='#ca9159';ctx.fillRect(Math.round(enemy.x),enemy.y-3,enemy.w-7,7);ctx.fillStyle=P.white;ctx.fillRect(Math.round(enemy.x)+enemy.w-7,enemy.y-2,6,2);}
    }
    const lady=ladyPosition(e.lady,e.platforms);if(lady)drawFrog(ctx,lady.x,lady.y,'up',false,true,0.7);
    const f=e.frog;
    if(e.state==='FROG_DYING')deathAnimation(ctx,f.x,f.y,e.stateFrame,['water','turtle','edge'].includes(e.deathCause||''));
    else if(!['HOME_REACHED','LEVEL_COMPLETE','GAME_OVER'].includes(e.state)){
      drawFrog(ctx,f.x,f.y,f.direction,!!f.hop&&f.hop.frame>1&&f.hop.frame<7);
      if(f.lady)drawFrog(ctx,f.x+1,f.y+2,f.direction,false,true,0.5);
    }
    ctx.restore();hud(ctx,e);
    if(title)this.title(wallTime);
    else if(e.state==='READY')this.banner('GET READY',P.yellow);
    else if(e.state==='PAUSED') {this.banner('PAUSED',P.yellow);centered(ctx,'PRESS START TO RESUME',156,P.white);}
    else if(e.state==='GAME_OVER')this.banner('GAME OVER',P.red);
    else if(e.state==='HOME_REACHED'){const s=`BONUS ${e.lastBonus}`;ctx.fillStyle=P.black;ctx.fillRect((224-textWidth(s))/2-4,126,textWidth(s)+8,15);centered(ctx,s,130,P.yellow);}
    else if(e.state==='LEVEL_COMPLETE'){this.banner('FIVE FROGS HOME!',e.stateFrame%20<10?P.green:P.white);centered(ctx,'1000 POINTS',156,P.yellow);}
  }
  private banner(value:string,color:string):void {
    const ctx=this.ctx;const w=textWidth(value)+16;ctx.fillStyle=P.black;ctx.fillRect((224-w)/2,113,w,25);centered(ctx,value,122,color);
  }
  private title(time:number):void {
    const ctx=this.ctx;ctx.fillStyle=P.black;ctx.fillRect(24,84,176,77);
    ctx.strokeStyle=P.darkGreen;ctx.strokeRect(24.5,84.5,175,76);
    centered(ctx,'FROGGER',94,P.green,3);text(ctx,"'81",160,118,P.yellow);
    if(Math.floor(time/650)%2===0)centered(ctx,'PRESS START',141,P.white);
    centered(ctx,'FIVE HOMES. ONE FROG.',179,P.white);
    centered(ctx,'DEMO PLAY',191,P.yellow);
  }
}
